import $ from 'jquery';

export default class SocialController {
    constructor(elem) {
        this.elem = elem;
        this.getFBPageShares();
    }

    getFBPageShares() {
        const countWrapper = this.elem.querySelector('.count-wrapper');
        if (countWrapper === null) return;
        if (countWrapper.dataset.show.toBoolean()) {
            $.get(`https://graph.facebook.com/?fields=og_object{likes.summary(total_count).limit(0)},share&id=${window.location.href}`,
                data => this.showFBPageShares(data));
        }
        else {
            this.elem.querySelector('.count-wrapper').remove();
        }
    }

    showFBPageShares(data) {
        if (data) {
            const shareCount = data.share.share_count;
            $(this.elem).find('.count-wrapper .count').html(shareCount);
        }
    }

    static init() {
        $(document).ready(() => {
            $('.social-sharing').each((index, elem) => {
                new SocialController(elem); // eslint-disable-line no-new
            });
        });
    }
}
